<app-loading *ngIf="contentReady"></app-loading>



<div class="bg-light" style="margin-bottom: 80px;">
    <div class="container">
        <div class="row justify-content-center">

            <div class="col-12" style=" margin-top: 15px;">
                <h4> {{"shopbycatagory"| transloco }}</h4>
            </div>
            <div class="scroll-menu">
                <div class="scroll-item" (click)="getProductsByPetAndCatagory(null)">
                    <img src="/assets/e-commerce/icons/35.webp">
                    <p>{{ "all" | transloco }}</p>
                </div>
                <div class="scroll-item" (click)="getProductsByPetAndCatagory(0)">
                    <img src="/assets/e-commerce/icons/18.webp">
                    <p>{{ "soft food" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(1)">
                    <img src="/assets/e-commerce/icons/17.webp">
                    <p>{{ "soft food can" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(2)">
                    <img src="/assets/e-commerce/icons/23.webp">
                    <p>{{ "dry food" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(3)">
                    <img src="/assets/e-commerce/icons/31.webp">
                    <p>{{ "bird food" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(4)">
                    <img src="/assets/e-commerce/icons/29.webp">
                    <p>{{ "medicine" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(5)">
                    <img src="/assets/e-commerce/icons/27.webp">
                    <p>{{ "supplement" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(6)">
                    <img src="/assets/e-commerce/icons/26.webp">
                    <p>{{ "accessories" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(7)">
                    <img src="/assets/e-commerce/icons/24.webp">
                    <p>{{ "toy" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(8)">
                    <img src="/assets/e-commerce/icons/25.webp">
                    <p>{{ "grooming" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(9)">
                    <img src="/assets/e-commerce/icons/28.webp">
                    <p>{{ "house" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(10)">
                    <img src="/assets/e-commerce/icons/30.webp">
                    <p>{{ "care" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(11)">
                    <img src="/assets/e-commerce/icons/32.webp">
                    <p>{{ "treats" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(12)">
                    <img src="/assets/e-commerce/icons/19.webp">
                    <p>{{ "training pads" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(13)">
                    <img src="/assets/e-commerce/icons/34.webp">
                    <p>{{ "bags" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(14)">
                    <img src="/assets/e-commerce/icons/33.webp">
                    <p>{{ "cleaning tools" | transloco }}</p>
                </div>

                <div class="scroll-item" (click)="getProductsByPetAndCatagory(15)">
                    <img src="/assets/e-commerce/icons/20.webp">
                    <p>{{ "litter" | transloco }}</p>
                </div>
            </div>
            <div class="scroll-menu tags">
                <div class="scroll-item" (click)="underPrice(50)">
                    <img src="/assets/e-commerce/icons/56.webp">
                    <p>{{"products under 50 egp"| transloco }}</p>
                </div>
                <div class="scroll-item" (click)="underPrice(100)">
                    <img src="/assets/e-commerce/icons/58.webp">
                    <p>{{"products under 100 egp"| transloco }}</p>
                </div>

                <div class="scroll-item" (click)="underPrice(200)">
                    <img src="/assets/e-commerce/icons/57.webp">
                    <p>{{"products under 200 egp"| transloco }}</p>
                </div>

            </div>
            @if (noData) {
            <app-nodata></app-nodata>
            <app-allbrands></app-allbrands>
            } @else {
            <div class="row" style="padding: 0;">

                <div class="col-6">
                    <h4> {{"allproducts"| transloco }}</h4>
                </div>
                <div class="col-6 text-align" style="margin-top: 5px;">
                    <p>{{stockTotal}} {{"Product"| transloco }}</p>
                </div>

                <app-product *ngFor="let element of allData" class="col-6 col-md-4 pointer" [element]="element"
                    [isAr]="isAr" [bybrand]='bybrand'></app-product>

            </div>

            }

            <app-allbrands *ngIf="page >= totalItems+1 && allData.length != 0"></app-allbrands>
        </div>
    </div>
</div>